import React, { Component } from "react";
import { Modal, Form, Card, Row, Col, Button } from "react-bootstrap";
import CustomButton from "../../../../components/buttons/customButton";
import whatsappBg from "../../../../images/messages/whatsappBg.png";

const WA_GREEN = "#25D366";
const WA_TEAL = "#128C7E";

const avatarColors = [
    "#f44336", "#e91e63", "#9c27b0", "#673ab7",
    "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4",
    "#009688", "#4caf50", "#8bc34a", "#cddc39",
    "#ffeb3b", "#ffc107", "#ff9800", "#ff5722",
];

const getAvatarColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return avatarColors[Math.abs(hash) % avatarColors.length];
};

const formatText = (text) => {
    if (!text || typeof text !== "string") return "";
    return text
        .replace(/\*([^*]+)\*/g, "<strong>$1</strong>")
        .replace(/\\n/g, "\n")
        .replace(/(https?:\/\/)([^ ]+)/g, '<a target="_blank" href="$&">$2</a>');
};

class WaTemplates extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTemplateData: [],
            headerTextDataDeatils: "",
            bodyTextDataDetails: "",
            searchTemplate: "",
            errors: {},
            selectPlaceHolderOptions: "1",
            headerInputs: [],
            inputs: [],
            selectedOption: null,
            loading: false,
        };
    }

    handleSelectionChange(selectedOption) {
        const { templates = [] } = this.props;
        const selectedTemplate = templates.find((item) => item.id === selectedOption.value) || {};

        const templateFormData1 = selectedTemplate.template_form || [];
        const { bodyText1, headerText1 } = Array.isArray(templateFormData1)
            ? templateFormData1.reduce((acc, { type, text }) => {
                  if (type === "BODY") acc.bodyText1 = text;
                  if (type === "HEADER") acc.headerText1 = text;
                  return acc;
              }, {})
            : {};

        const placeholderRegex = /\{\{(\d+)\}\}/g;
        const placeholderHeader = (headerText1 || "").match(placeholderRegex) || [];
        const placeholder = (bodyText1 || "").match(placeholderRegex) || [];

        this.setState({
            selectedOption,
            selectedTemplateData: [selectedTemplate],
            errors: {},
            selectPlaceHolderOptions: "1",
            headerTextDataDeatils: headerText1 || "",
            bodyTextDataDetails: bodyText1 || "",
            inputs: Array(placeholder.length).fill(""),
            headerInputs: Array(placeholderHeader.length).fill(""),
        });
    }

    handleHeaderInputChange(index, value) {
        const newInputs = [...this.state.headerInputs];
        newInputs[index] = value;
        this.setState({ headerInputs: newInputs, errors: {} });
    }

    handleInputChange(index, value) {
        const newInputs = [...this.state.inputs];
        newInputs[index] = value;
        this.setState({ inputs: newInputs, errors: {} });
    }

    validateForm() {
        const { selectedOption, headerInputs, inputs } = this.state;
        let validations = [];

        if (selectedOption === null) {
            validations.push({ field: "template", message: "Template is required" });
        }
        headerInputs.forEach((val, i) => {
            if (!val.trim()) validations.push({ field: `header_${i}`, message: `Header variable ${i + 1} is required` });
        });
        inputs.forEach((val, i) => {
            if (!val.trim()) validations.push({ field: `body_${i}`, message: `Body variable ${i + 1} is required` });
        });

        if (validations.length > 0) {
            console.error(validations[0].message);
            const errors = {};
            validations.forEach((rule) => { errors[rule.field] = rule.message; });
            this.setState({ errors });
            return false;
        }

        this.setState({ errors: {} });
        return true;
    }

    async handleSubmit(e) {
        e.preventDefault();
        const isValid = this.validateForm();
        if (!isValid) return;

        const { selectedOption, headerInputs, inputs, selectPlaceHolderOptions } = this.state;
        const { selectedUser, handleClose, onSendTemplate, campaignInputParams = [] } = this.props;

        const getMappedText = (text) => {
            if (selectPlaceHolderOptions === "2") {
                const match = campaignInputParams.find((item) => item.template_variable === text);
                return match ? match.id : text;
            }
            return text;
        };

        const variables = [];
        if (headerInputs.length > 0) {
            variables.push({
                type: "header",
                parameters: headerInputs.map((text) => ({ type: "text", text: getMappedText(text), mode: "static", key: "" })),
            });
        }
        if (inputs.length > 0) {
            variables.push({
                type: "body",
                parameters: inputs.map((text) => ({ type: "text", text: getMappedText(text), mode: "static", key: "" })),
            });
        }

        this.setState({ loading: true });
        try {
            if (onSendTemplate) {
                const result = await onSendTemplate({
                    receiver_contact_id: selectedUser,
                    template_id: selectedOption?.value,
                    variables,
                });
                if (result && result.success) {
                    console.log(result.message || "Template sent successfully");
                    handleClose();
                } else {
                    console.error(result?.message || "Failed to send template");
                }
            }
        } catch {
            console.error("Server error. Please try again.");
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { show, handleClose, templates = [], campaignInputParams = [] } = this.props;
        const {
            selectedTemplateData, searchTemplate, selectedOption, errors,
            headerInputs, inputs, selectPlaceHolderOptions, loading,
            headerTextDataDeatils, bodyTextDataDetails,
        } = this.state;

        const approvedTemplates = templates.filter((item) => item.status === "Approved");
        const templeData = approvedTemplates.map((item) => ({ value: item.id, label: item.template_name }));
        const filteredTemplates = templeData.filter((item) =>
            item.label.toLowerCase().includes(searchTemplate.toLowerCase())
        );

        const templateFormData =
            (selectedTemplateData[0] || {}).template_form instanceof Array
                ? (selectedTemplateData[0] || {}).template_form
                : (selectedTemplateData[0] || {}).template_form
                ? (selectedTemplateData[0] || {}).template_form.components
                : [];

        const { headerText, bodyText, footerText, buttons, image, video, document: docUrl } =
            Array.isArray(templateFormData)
                ? templateFormData.reduce((accumulator, { type, text, format, example, buttons }) => {
                      const normalizedFormat = format ? format.toLowerCase() : "";
                      if (type === "HEADER") {
                          if (normalizedFormat === "image" && example?.header_handle) accumulator.image = example.header_handle[0];
                          else if (normalizedFormat === "video" && example?.header_handle) accumulator.video = example.header_handle[0];
                          else if (normalizedFormat === "document" && example?.header_handle) accumulator.document = example.header_handle[0];
                          else accumulator.headerText = text;
                      } else if (type === "BODY") {
                          accumulator.bodyText = text;
                      } else if (type === "FOOTER") {
                          accumulator.footerText = text;
                      } else if (type === "BUTTONS") {
                          accumulator.buttons = buttons;
                      }
                      return accumulator;
                  }, {})
                : {};

        const placeholderRegex = /\{\{(\d+)\}\}/g;
        const textParts = (bodyText || "").split(placeholderRegex);
        const headerTextParts = (headerText || "").split(placeholderRegex);

        // Substitute the values being typed into {{1}}, {{2}}… so the preview
        // shows the real message (e.g. "Hi sowjanya"); keep {{n}} until filled.
        const fillVars = (text, values = []) => {
            let out = text || "";
            values.forEach((val, i) => {
                out = out.split(`{{${i + 1}}}`).join(val || `{{${i + 1}}}`);
            });
            return out;
        };

        const headerTextFormat = fillVars(headerTextDataDeatils, headerInputs).replace(/\n/g, "<br>").replace(/ \*(\S*?)\* /g, " <b>$1</b> ");
        const bodyTextFormat = fillVars(bodyTextDataDetails, inputs).replace(/\n/g, "<br>").replace(/ \*(\S*?)\* /g, " <b>$1</b> ");

        return (
            <Modal show={show} onHide={handleClose} size="lg" centered>
                <Modal.Header style={{ background: `linear-gradient(135deg, ${WA_TEAL}, ${WA_GREEN})`, color: "#fff", border: "none", padding: "14px 20px" }}>
                    <div className="d-flex align-items-center">
                        <div style={{ width: 40, height: 40, borderRadius: "50%", background: "rgba(255,255,255,0.18)", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 12 }}>
                            <i className="fab fa-whatsapp" style={{ fontSize: 22 }} />
                        </div>
                        <div>
                            <Modal.Title style={{ fontSize: "1.1rem", fontWeight: 600, lineHeight: 1.15 }}>Approved Templates</Modal.Title>
                            <small style={{ opacity: 0.85, fontSize: 11.5 }}>
                                {approvedTemplates.length} template{approvedTemplates.length === 1 ? "" : "s"} available
                            </small>
                        </div>
                    </div>
                    <button type="button" className="close" style={{ color: "#fff", opacity: 0.9, textShadow: "none", fontSize: 26 }} onClick={handleClose}>
                        <span>&times;</span>
                    </button>
                </Modal.Header>

                <Modal.Body>
                    <Row>
                        {/* Template list */}
                        <Col xs={12} md={4}>
                            <div className="input-group input-group-sm mb-2">
                                <Form.Control
                                    size="sm"
                                    value={searchTemplate}
                                    onChange={(e) => this.setState({ searchTemplate: e.target.value.replace(/^\s+/, "").slice(0, 10) })}
                                    placeholder="Search template..."
                                    maxLength={10}
                                />
                                {searchTemplate && (
                                    <div className="input-group-append">
                                        <button className="btn btn-outline-secondary btn-sm" onClick={() => this.setState({ searchTemplate: "" })}>
                                            <i className="fas fa-times" />
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div style={{ maxHeight: "50vh", overflowY: "auto" }}>
                                {filteredTemplates.length > 0 ? (
                                    filteredTemplates.map((item) => {
                                        const avatarColor = getAvatarColor(item.label + item.value);
                                        const isSelected = selectedOption?.value === item.value;
                                        return (
                                            <div
                                                key={item.value}
                                                onClick={() => this.handleSelectionChange(item)}
                                                style={{
                                                    display: "flex", alignItems: "center",
                                                    padding: "9px 12px", cursor: "pointer",
                                                    borderRadius: 8, marginBottom: 4,
                                                    borderLeft: isSelected ? `3px solid ${WA_GREEN}` : "3px solid transparent",
                                                    backgroundColor: isSelected ? "#e7f9ee" : "transparent",
                                                    transition: "background-color 0.15s ease",
                                                }}
                                                onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.backgroundColor = "#f5f5f5"; }}
                                                onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.backgroundColor = "transparent"; }}
                                            >
                                                <div style={{
                                                    width: 38, height: 38, borderRadius: "50%",
                                                    backgroundColor: avatarColor, color: "#fff",
                                                    display: "flex", alignItems: "center", justifyContent: "center",
                                                    fontWeight: 600, fontSize: 15, flexShrink: 0,
                                                }}>
                                                    {item.label[0].toUpperCase()}
                                                </div>
                                                <div className="ml-2" style={{ overflow: "hidden" }}>
                                                    <div style={{ fontSize: 13.5, fontWeight: isSelected ? 600 : 500, color: "#1f2937", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                        {item.label}
                                                    </div>
                                                    <div style={{ fontSize: 10.5, color: WA_TEAL, fontWeight: 600, letterSpacing: 0.3 }}>
                                                        <i className="fas fa-check-circle mr-1" style={{ fontSize: 9 }} />APPROVED
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <p className="text-success text-center mt-3">No Approved Templates Found</p>
                                )}
                            </div>
                        </Col>

                        {/* Template preview + inputs */}
                        <Col xs={12} md={8} style={{ maxHeight: "50vh", overflowY: "auto", marginTop: 12 }}>
                            {selectedOption && selectedTemplateData.length > 0 ? (
                                <div className="p-1">
                                  <div style={{ backgroundImage: `url(${whatsappBg})`, backgroundSize: "cover", backgroundPosition: "center", borderRadius: 10, padding: "18px 14px", marginBottom: 14, border: "1px solid #e6e6e6" }}>
                                    <div style={{ background: "#ffffff", borderRadius: "0 8px 8px 8px", padding: "9px 11px 7px", boxShadow: "0 1px 2px rgba(0,0,0,0.13)", maxWidth: "92%", fontSize: 13.5, lineHeight: 1.45, color: "#111b21" }}>
                                    {image && <img src={image} alt="Template" style={{ maxWidth: "100%", borderRadius: 8, marginBottom: 8 }} />}
                                    {video && (
                                        <video controls style={{ width: "100%", height: 180, borderRadius: 8, marginBottom: 8 }}>
                                            <source src={video} type="video/mp4" />
                                        </video>
                                    )}
                                    {docUrl && (
                                        <Card className="mb-2">
                                            <Card.Body className="text-center">
                                                <a href={docUrl} target="_blank" rel="noopener noreferrer">View Document</a>
                                            </Card.Body>
                                        </Card>
                                    )}

                                    <div className="mb-2">
                                        <div dangerouslySetInnerHTML={{ __html: formatText(headerTextFormat) }} />
                                        <div dangerouslySetInnerHTML={{ __html: formatText(bodyTextFormat) }} />
                                    </div>
                                    <small className="text-muted">{footerText}</small>

                                    {buttons && buttons.length > 0 && (
                                        <div className="row mt-2">
                                            {buttons.map((button, index) => (
                                                <div key={index} className={buttons.length > 3 ? "col-6 mb-1" : "col-12 mb-1"}>
                                                    {button.type === "QUICK_REPLY" && (
                                                        <button className="btn btn-primary btn-sm w-100">
                                                            <i className="fas fa-comment mr-1" />{button.text}
                                                        </button>
                                                    )}
                                                    {button.type === "url" && (
                                                        <button className="btn btn-outline-primary btn-sm w-100">
                                                            <i className="fas fa-external-link-alt mr-1" />{button.text}
                                                        </button>
                                                    )}
                                                    {button.type !== "QUICK_REPLY" && button.type !== "url" && (
                                                        <button className="btn btn-outline-primary btn-sm w-100">
                                                            <i className="fas fa-phone mr-1" />{button.text}
                                                        </button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    </div>
                                  </div>

                                    {headerTextParts.length > 1 && (
                                        <Card className="mt-2">
                                            <Card.Body>
                                                <p className="mb-2"><strong>Header Variables:</strong></p>
                                                {headerTextParts.map((part, index) =>
                                                    index % 2 !== 0 ? (
                                                        selectPlaceHolderOptions === "1" ? (
                                                            <Form.Control
                                                                key={index}
                                                                size="sm"
                                                                className="mb-1"
                                                                maxLength={20}
                                                                isInvalid={!!errors[`header_${(index - 1) / 2}`]}
                                                                value={headerInputs[(index - 1) / 2] || ""}
                                                                onChange={(e) => this.handleHeaderInputChange((index - 1) / 2, e.target.value)}
                                                                placeholder={`Enter text for {{${part}}}`}
                                                            />
                                                        ) : (
                                                            <Form.Control
                                                                key={index}
                                                                as="select"
                                                                size="sm"
                                                                className="mb-1"
                                                                value={headerInputs[(index - 1) / 2] || ""}
                                                                onChange={(e) => this.handleHeaderInputChange((index - 1) / 2, e.target.value)}
                                                            >
                                                                <option value="">Select...</option>
                                                                {campaignInputParams.map((item) => (
                                                                    <option key={item.id} value={item.template_variable}>{item.template_variable}</option>
                                                                ))}
                                                            </Form.Control>
                                                        )
                                                    ) : null
                                                )}
                                            </Card.Body>
                                        </Card>
                                    )}

                                    {textParts.length > 1 && (
                                        <Card className="mt-2">
                                            <Card.Body>
                                                <p className="mb-2"><strong>Body Variables:</strong></p>
                                                {textParts.map((part, index) =>
                                                    index % 2 !== 0 ? (
                                                        selectPlaceHolderOptions === "1" ? (
                                                            <Form.Control
                                                                key={index}
                                                                size="sm"
                                                                className="mb-1"
                                                                maxLength={20}
                                                                isInvalid={!!errors[`body_${(index - 1) / 2}`]}
                                                                value={inputs[(index - 1) / 2] || ""}
                                                                onChange={(e) => this.handleInputChange((index - 1) / 2, e.target.value)}
                                                                placeholder={`Enter text for {{${part}}}`}
                                                            />
                                                        ) : (
                                                            <Form.Control
                                                                key={index}
                                                                as="select"
                                                                size="sm"
                                                                className="mb-1"
                                                                value={inputs[(index - 1) / 2] || ""}
                                                                onChange={(e) => this.handleInputChange((index - 1) / 2, e.target.value)}
                                                            >
                                                                <option value="">Select...</option>
                                                                {campaignInputParams.map((item) => (
                                                                    <option key={item.id} value={item.template_variable}>{item.template_variable}</option>
                                                                ))}
                                                            </Form.Control>
                                                        )
                                                    ) : null
                                                )}
                                            </Card.Body>
                                        </Card>
                                    )}
                                </div>
                            ) : (
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 300, textAlign: "center" }}>
                                    <div style={{ width: 84, height: 84, borderRadius: "50%", background: "#e7f9ee", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
                                        <i className="fab fa-whatsapp" style={{ fontSize: 42, color: WA_GREEN }} />
                                    </div>
                                    <h6 style={{ color: "#374151", fontWeight: 600, marginBottom: 4 }}>No template selected</h6>
                                    <small className="text-muted">Pick a template on the left to preview the message</small>
                                </div>
                            )}
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <CustomButton
                        status={loading ? "loading" : "idle"}
                        onClick={(e) => this.handleSubmit(e)}
                        label="Send Template"
                        loadingLabel="sending..."
                    />
                </Modal.Footer>
            </Modal>
        );
    }
}

export default WaTemplates;
